import { useTranslation } from 'next-i18next'
import { useState } from 'react'

import { useSetUserSettingsMutation } from '~/redux/apis/user-settings-api'

export default function LeagueOptOut({
  leagueParticipation,
  hasDescription,
  hasPadding,
}: {
  leagueParticipation: boolean
  hasDescription?: boolean
  hasPadding?: boolean
}): React.ReactElement {
  const { t } = useTranslation('settings')
  const [isParticipating, setIsParticipating] = useState<boolean>(leagueParticipation)
  const [setLeagueParticipationMutation] = useSetUserSettingsMutation()

  const onChangeParticipation = () => {
    const joinLeaderboard = !isParticipating
    setLeagueParticipationMutation({ joinLeaderboard })
    setIsParticipating(!isParticipating)
  }

  return (
    <div className={`flex flex-col text-black bg-white rounded ${hasPadding ? 'p-2' : ''}`}>
      <div className="flex justify-between font-semibold">
        <p>{t('participant')}</p>
        <div className="flex gap-2">
          <p>{isParticipating ? t('yes') : t('no')}</p>
          <button
            className={`${
              isParticipating ? 'bg-gradient-to-b from-purple-medium-light to-purple-dark-top' : 'bg-purple-gdark'
            } w-12 h-full py-px rounded-full cursor-pointer transition duration-200`}
            onClick={onChangeParticipation}
          >
            <span
              className={`flex rounded-full w-6 h-6 bg-white transition duration-200 ${
                isParticipating ? 'translate-x-full -ml-px' : 'translate-x-0 ml-px'
              }`}
            />
          </button>
        </div>
      </div>
      {hasDescription && !leagueParticipation && <p>{t('participantDescription')}</p>}
    </div>
  )
}
